/**
 * @generated SignedSource<<6a622c3ccbbe286fe0564af388855ebd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useSpaceEnabledContentTypes_space$data = {
  readonly id: string | null;
  readonly key: string | null;
  readonly spaceTypeSettings: {
    readonly enabledContentTypes: {
      readonly isBlogsEnabled: boolean;
      readonly isDatabasesEnabled: boolean;
      readonly isEmbedsEnabled: boolean;
      readonly isFoldersEnabled: boolean;
      readonly isLivePagesEnabled: boolean;
      readonly isSlidesEnabled: boolean;
      readonly isWhiteboardsEnabled: boolean;
    };
  };
  readonly " $fragmentType": "useSpaceEnabledContentTypes_space";
};
export type useSpaceEnabledContentTypes_space$key = {
  readonly " $data"?: useSpaceEnabledContentTypes_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSpaceEnabledContentTypes_space">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useSpaceEnabledContentTypes_space",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "concreteType": "SpaceTypeSettings",
      "kind": "LinkedField",
      "name": "spaceTypeSettings",
      "plural": false,
      "selections": [
        {
          "concreteType": "EnabledContentTypes",
          "kind": "LinkedField",
          "name": "enabledContentTypes",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isBlogsEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "isDatabasesEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "isEmbedsEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "isLivePagesEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "isSlidesEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "isWhiteboardsEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "isFoldersEnabled"
            }
          ]
        }
      ]
    }
  ],
  "type": "Space"
};

(node as any).hash = "b4c0be9fdc8089ef19cf4d9ec776f16e";

export default node;
